import React, { useState } from 'react';
import { CheckCircle2, Upload } from 'lucide-react';
interface ApplyFormProps {
  jobTitle: string;
  onClose: () => void;
}
export function ApplyForm({
  jobTitle,
  onClose
}: ApplyFormProps) {
  const [submitted, setSubmitted] = useState(false);
  const [fileName, setFileName] = useState<string | null>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  if (submitted) {
    return <div className="text-center py-8" data-id="element-18">
        <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-5" data-id="element-19">
          <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-20" />
        </div>
        <h3 className="text-2xl font-heading font-bold text-navy mb-2" data-id="element-21">
          Application received!
        </h3>
        <p className="text-muted mb-6 max-w-sm mx-auto" data-id="element-22">
          Thanks for applying for the{' '}
          <span className="font-semibold text-navy" data-id="element-23">{jobTitle}</span> role.
          We'll review your application and get back to you within 5 business
          days.
        </p>
        <button onClick={onClose} className="px-6 py-3 bg-navy text-white font-bold rounded-md hover:bg-navy-deep transition-colors" data-id="element-24">
          Close
        </button>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-5" data-id="element-25">
      <div className="bg-blue-soft/60 border border-blue/10 rounded-lg p-4" data-id="element-26">
        <div className="text-xs uppercase tracking-wider text-muted font-semibold mb-0.5" data-id="element-27">
          Applying for
        </div>
        <div className="font-heading font-bold text-navy" data-id="element-28">{jobTitle}</div>
      </div>

      <div className="grid md:grid-cols-2 gap-4" data-id="element-29">
        <div data-id="element-30">
          <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-31">
            First Name *
          </label>
          <input type="text" required className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm" data-id="element-32" />
        </div>
        <div data-id="element-33">
          <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-34">
            Last Name *
          </label>
          <input type="text" required className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm" data-id="element-35" />
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4" data-id="element-36">
        <div data-id="element-37">
          <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-38">
            Email *
          </label>
          <input type="email" required className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm" data-id="element-39" />
        </div>
        <div data-id="element-40">
          <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-41">
            Phone
          </label>
          <input type="tel" className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm" data-id="element-42" />
        </div>
      </div>

      <div data-id="element-43">
        <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-44">
          LinkedIn / Portfolio URL
        </label>
        <input type="url" placeholder="https://linkedin.com/in/your-profile" className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm" data-id="element-45" />
      </div>

      {/* Resume upload */}
      <div data-id="element-46">
        <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-47">
          Resume / CV *
        </label>
        <label className="flex items-center gap-3 px-4 py-3 border-2 border-dashed border-gray-300 rounded-md cursor-pointer hover:border-blue hover:bg-blue-soft/30 transition-colors" data-id="element-48">
          <Upload className="w-5 h-5 text-blue flex-shrink-0" data-id="element-49" />
          <div className="text-sm" data-id="element-50">
            {fileName ? <span className="text-navy font-medium" data-id="element-51">{fileName}</span> : <>
                <span className="text-navy font-medium" data-id="element-52">Click to upload</span>
                <span className="text-muted" data-id="element-53"> — PDF, DOCX (max 5MB)</span>
              </>}
          </div>
          <input type="file" accept=".pdf,.doc,.docx" required className="sr-only" onChange={e => setFileName(e.target.files?.[0]?.name || null)} data-id="element-54" />
        </label>
      </div>

      <div data-id="element-55">
        <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-56">
          Why do you want to join Global Remote?
        </label>
        <textarea rows={4} placeholder="Tell us about yourself and what excites you about this role..." className="w-full px-4 py-2.5 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent text-sm resize-none" data-id="element-57"></textarea>
      </div>

      <button type="submit" className="w-full py-3.5 bg-navy text-white font-bold rounded-md hover:bg-navy-deep transition-colors" data-id="element-58">
        Submit Application
      </button>
    </form>;
}